import {AuthenticationService, authUserType} from "app/services/auth.service";
import {ActivatedRoute, Router} from "@angular/router";

export const login = (
  auth: AuthenticationService,
  router: Router,
  route: ActivatedRoute,
  user: authUserType,
  returnUrl: string | null,
  openContinueOnModal: ((url: string) => void) | null) => {
  if (user.trustedComputer) {
    localStorage.setItem('trustedComputer_' + user.userName.toLowerCase().trim(), user.trustedComputer);
  }

  if (sessionStorage.getItem('isKYCredirect')) {
    sessionStorage.removeItem('isKYCredirect');
    auth.openKYC(true);
  } else if (!auth.user?.isClient) {
    router.navigate(["/document"]);
  } else {
    let url = returnUrl ?? auth.getHomeLink();
    if (sessionStorage.getItem('guid')) {
      url = "/portfolio";
    }
    if (openContinueOnModal
      && navigator.userAgent.match(/Android|webOS|iPhone|iPad|iPod/i)
      && (route.snapshot.url[0].path === 'forgotpassword'
        || route.snapshot.url[0].path === 'forgotusername')) {
      openContinueOnModal(url);
      return;
    }

    router.navigateByUrl(url);
  }
};